import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { universityClient } from '../client/universityClient';


export type Params = {
  id: number;
};

type Options = {

};

const defaultOptions: Partial<Options> = {
};

export const useUniversity = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: university } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getUniversity, params.id],
    queryFn: () => universityClient.getUniversity(params),
  });

  return {
    ...rest,
    university,
  };
};
